// Skinline: puntitos de posición de la galería de producto (móvil).
// Se apoya en el slider de Sense: escucha su evento 'slideChanged' y usa su scroll.
(function () {
  function init(viewer) {
    if (viewer.dataset.skinlineDots) return;
    viewer.dataset.skinlineDots = 'true';

    const slider = viewer.querySelector('[id^="Slider-"]');
    const dots = Array.from(viewer.querySelectorAll('.skinline-dots__dot'));
    if (!slider || dots.length < 2) return;

    const setActive = (index) => {
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    viewer.addEventListener('slideChanged', (event) => setActive(event.detail.currentPage - 1));

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const slides = Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter((el) => el.clientWidth > 0);
        if (slides[i]) slider.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('slider-component.skinline-gallery').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
